import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@feature/utils';

import { ProjectCard } from './components/Card/ProjectCard';
import { getProjectPagedOptions } from './model/ProjectQuery';

export function ProjectBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { search, searchProps } = useSearch();
  const { pagination, useTotalElements, ...paginationProps } = usePagination({ search });

  const { data } = useSuspenseQuery(
    getProjectPagedOptions({
      ...pagination,
      sortDirection,
      search,
    }),
  );
  useTotalElements(data);

  return (
    <Browse
      actions={<AddButtonLink />}
      title={t('projects.title')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('projects.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('projects.sortedByPublishDate')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={project => (
        <ProjectCard
          key={project.id}
          project={project}
          to={`${project.id}`}
        />
      )}
    />
  );
}
